import React from 'react';

import {Button, CheckIcon, ModalPopup, Tab, Tabs} from '@kit';

import type {SpellManagementTab} from '../model/spell-list';
import {useCharacter} from '../character-context';
import {SpellList} from './spell-list';
import {SpellbookAdd} from './spellbook-add';

import css from './sheet.module.css';

type Props = {
	open: boolean;
	tabs: SpellManagementTab[];
	onClose(): void;
};

export const SpellManagement: React.FC<Props> = ({open, tabs, onClose}) => {
	const {catalog} = useCharacter();
	const tabTitle = ({classId}: SpellManagementTab) =>
		classId ? catalog.getClass(classId)?.title || classId : 'Другие';

	return (
		<ModalPopup open={open} onClose={onClose} header="Управление заклинаниями" maxWidth={800}>
			{tabs.length > 1 ? (
				<Tabs>
					{tabs.map((tab) => (
						<Tab key={tab.key} header={tabTitle(tab)}>
							<SpellManagementContent tab={tab} />
						</Tab>
					))}
				</Tabs>
			) : (
				tabs[0] && <SpellManagementContent tab={tabs[0]} />
			)}
			<div className={css.modalButtons}>
				<Button appearance="primary" icon={<CheckIcon />} onClick={onClose}>
					Готово
				</Button>
			</div>
		</ModalPopup>
	);
};

const SpellManagementContent: React.FC<{tab: SpellManagementTab}> = ({tab: {classId, preparation, entries}}) => {
	const {character} = useCharacter();
	const hasSpellbook =
		!!classId &&
		character.features.some(
			({owner, feature}) => owner.classId === classId && feature.props?.spellcasting?.mode === 'spellbook',
		);
	return (
		<>
			<div className={css.spellManagementHeader}>
				{preparation && (
					<span className={css.muted}>
						Подготовлено {preparation.choice.selected.length}
						{preparation.limit !== undefined && ` из ${preparation.limit}`}
					</span>
				)}
				{hasSpellbook && <SpellbookAdd classId={classId} />}
			</div>
			<SpellList entries={entries} withPreparation />
		</>
	);
};
